// Angular modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// 3rd party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxScrollViewModule,
    DxResponsiveBoxModule,
    DxDrawerModule,
    DxPopupModule,
    DxContextMenuModule,
    DxListModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxMenuModule,
    DxDataGridModule,
    DxMultiViewModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxFormModule,
    DxDateBoxModule,
    DxToolbarModule
} from 'devextreme-angular';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// Modules imports
import { ManagementCommonModule } from '../management-common/management-common.module';
import { SharedModule } from '../shared-module/shared.module';
import { SharedCirabooksModule } from '../cirabooks/shared-cirabooks-module/shared-cirabooks.module';

// Component imports
import { SearchComponent } from './search.component';
import { SearchPropertiesCurrentOwnersComponent } from './search-properties-current-owners/search-properties-current-owners.component';
import { SearchPropertiesAllOwnersComponent } from './search-properties-all-owners/search-properties-all-owners.component';
import { SearchProjectTasksComponent } from './search-project-tasks/search-project-tasks.component';
import { SearchWorkOrdersComponent } from './search-work-orders/search-work-orders.component';
import { SearchVendorDisbursementsCheckComponent } from './search-vendor-disbursements-check/search-vendor-disbursements-check.component';
import { SearchInvoicesWorkflowComponent } from './search-invoices-workflow/search-invoices-workflow.component';
import { SearchViolationNoticesComponent } from './search-violation-notices/search-violation-notices.component';
import { SearchArchitecturalApplicationsComponent } from './search-architectural-applications/search-architectural-applications.component';
import { SearchVendorsComponent } from './search-vendors/search-vendors.component';
import { SearchCommunityComponent } from './search-community/search-community.component';
import { SearchIndividualOwnerComponent } from './search-individual-owner/search-individual-owner.component';
import { SearchCompanyOwnerComponent } from './search-company-owner/search-company-owner.component';
import { SearchNotesEditorComponent } from './search-notes-editor/search-notes-editor.component';
import { SearchTransactionLogComponent } from './search-transaction-log/search-transaction-log.component';

// Service imports
import { SearchService } from './_services/data-services/search.service';

@NgModule({
    declarations: [
        SearchComponent,
        SearchPropertiesCurrentOwnersComponent,
        SearchPropertiesAllOwnersComponent,
        SearchProjectTasksComponent,
        SearchWorkOrdersComponent,
        SearchVendorDisbursementsCheckComponent,
        SearchInvoicesWorkflowComponent,
        SearchViolationNoticesComponent,
        SearchArchitecturalApplicationsComponent,
        SearchVendorsComponent,
        SearchCommunityComponent,
        SearchIndividualOwnerComponent,
        SearchCompanyOwnerComponent,
        SearchNotesEditorComponent,
        SearchTransactionLogComponent
    ],
    exports: [
        SearchPropertiesCurrentOwnersComponent,
        SearchCommunityComponent,
        SearchIndividualOwnerComponent,
        SearchCompanyOwnerComponent
    ],
    imports: [
        CommonModule,
        DxBoxModule,
        DxButtonModule,
        DxResponsiveBoxModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxDrawerModule,
        DxPopupModule,
        DxListModule,
        DxContextMenuModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxDropDownButtonModule,
        DxMenuModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxMultiViewModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxFormModule,
        DxDateBoxModule,
        DxToolbarModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        SharedCirabooksModule
    ],
    providers: [SearchService]
})
export class SearchModule {}
